export default class AppApiConfig {
  // static API_ENDPOINT = 'https://be-medi-sync.reyna-solutions.in/'
  static API_ENDPOINT = 'https://livestock-player-nested-exclusive.trycloudflare.com/'

  static API_ADMIN_ENDPOINT = 'api'

  /* TEST API */
  static API_GET_USERS_URL = 'https://jsonplaceholder.typicode.com/users'
  /* TEST API */

  /* AUTH API */
  static API_USER_AUTH_URL = this.API_ADMIN_ENDPOINT + '/auth'
  static API_USER_LOGIN_URL = this.API_USER_AUTH_URL + '/login'
  /* AUTH API */
}
